import { CopyOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { message } from 'antd';
import { ReturnOrderListItemV2 } from 'services/api/refund';
import copyText from 'utils/copyText';
import { useMemoizedFn } from 'ahooks';

interface DisplayNumberProps {
  data: ReturnOrderListItemV2;
}

export const DisplayNumber = (props: DisplayNumberProps) => {
  const {
    data: { platform, returnSn, orderSn },
  } = props;
  const { t } = useTranslate();

  const handleReturnSnCopy = useMemoizedFn(() => {
    copyText(returnSn).then(() => message.success(t('ViewRefund.复制成功')));
  });
  const handleOrderSnCopy = useMemoizedFn(() => {
    copyText(orderSn).then(() => message.success(t('ViewRefund.复制成功')));
  });

  return (
    <>
      {platform !== 'MERCADO' && (
        <div className="inline-flex items-center group relative" onClick={handleReturnSnCopy}>
          {t('ViewRefund.退款单号')}: {returnSn}
          <CopyOutlined className="absolute top-1 -right-3.5 invisible group-hover:visible" />
        </div>
      )}
      <div className="inline-flex items-center group relative" onClick={handleOrderSnCopy}>
        {t('translation.订单编号')}: {orderSn}
        <CopyOutlined className="absolute top-1 -right-3.5 invisible group-hover:visible" />
      </div>
    </>
  );
};
